import React, { useCallback, useContext, useMemo } from "react";
import { AppContext } from "../app-context";
import { USER_GROUP, UserType } from "../constants/authorizedUsers";
export const useCsDashboard = () => {
    const { csDashboardPermission, csDashboardUserRoles, isCsDashboardUser, companyId } = useContext(AppContext);

    const checkRole = useCallback(
        (role: string[]) => {
            return (
                isCsDashboardUser &&
                Array.isArray(role) &&
                !!role?.length &&
                role?.some((r) => csDashboardUserRoles?.includes(r))
            );
        },
        [csDashboardUserRoles]
    );

    const checkPermission = useCallback(
        (operation?: string | string[], filterType: "and" | "or" = "or") => {
            if (!isCsDashboardUser) {
                return false;
            }
            if (Array.isArray(operation)) {
                if (filterType === "and") {
                    return operation.every((op) => csDashboardPermission?.includes(op));
                } else {
                    return operation.length > 0 ? operation.some((op) => csDashboardPermission?.includes(op)) : true;
                }
            } else {
                return operation ? !!csDashboardPermission?.includes?.(operation) : false;
            }
        },
        [csDashboardPermission]
    );

    const derivedRole = useMemo(() => {
        return {
            isTso: checkRole([UserType.TSO]) && checkPermission("tagAgent"),
            isTsoV2: checkRole(USER_GROUP.TSO_V2),
            isInternalUser: !!checkRole(USER_GROUP.INTERNAL_USERS),
            isSuperUser: !!checkRole(USER_GROUP.SUPER_USERS),
            isSuperAdmin: !!checkRole([UserType.SUPER_ADMIN]),
            isDeveloper: !!checkRole([UserType.DEVELOPER]),
            isAdmin: !!checkRole(USER_GROUP.ADMINS)
        };
    }, [csDashboardPermission, csDashboardUserRoles]);

    return {
        checkPermission: checkPermission,
        isCsDashboardUser: !!isCsDashboardUser,
        currentOperation: undefined as string[] | undefined,
        currentRole: undefined as string[] | undefined,
        checkRole: checkRole,
        ...(isCsDashboardUser && {
            ...derivedRole,
            currentOperation: csDashboardPermission,
            currentRole: csDashboardUserRoles,
            csUserCompanyId: Number(companyId)
        })
    };
};
